var _defs, _circle, _circle2, _circle3, _use, _use2, _use3, _use4, _use5, _use6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerCashDrops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 170,
    viewBox: "0 0 220 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd-card",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFA45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8590C"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bd-bill",
    viewBox: "0 0 52 34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 32,
    rx: 7,
    fill: "url(#bd-card)",
    stroke: "#FFBE8A",
    strokeOpacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 17,
    r: 8,
    fill: "#7A2E00",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5l7 7M29.5 13.5l-7 7",
    stroke: "#FFE2C8",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 120,
    r: 11,
    stroke: "#FF8A3D",
    strokeOpacity: 0.45,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 26,
    r: 7,
    stroke: "#FF8A3D",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 6,
    stroke: "#FF8A3D",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 92,
    y: 14,
    width: 52,
    height: 34,
    transform: "rotate(-14 118 31)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 150,
    y: 40,
    width: 52,
    height: 34,
    transform: "rotate(10 176 57)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 86,
    y: 70,
    width: 52,
    height: 34,
    transform: "rotate(8 112 87)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 140,
    y: 96,
    width: 52,
    height: 34,
    transform: "rotate(-12 166 113)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 40,
    y: 56,
    width: 44,
    height: 29,
    transform: "rotate(-22 62 70)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#bd-bill",
    x: 56,
    y: 106,
    width: 44,
    height: 29,
    transform: "rotate(16 78 120)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCashDrops);
export default __webpack_public_path__ + "static/media/bannerCashDrops.005a3fe5aa73534ca807397daab91a76.svg";
export { ForwardRef as ReactComponent };